import React, { useState, useEffect, useRef } from "react"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Dropdown } from "primereact/dropdown"
import { Button } from "primereact/button"
import { MultiSelect } from "primereact/multiselect"
import { useTranslation } from "react-i18next"
import { useAppContext, usePersistedState } from "../../AppContext"
import func from "../../services/functions"
import moment from "moment"
import mainAxios from "../../services/mainAxios"
import CashRegisterThermal from "./CashRegisterThermal"
import DateRange from "../global/DateRange"
import Select from "react-select"
import selectStyle from "../../design/selectStyle"
import { Menu } from "primereact/menu"
import { useMemo } from "react"
import ExportCsvMultiple from "../global/ExporCsvMultiple"
import Loader from "../Layout/Loader"
import bigDecimal from "js-big-decimal"
import OpenTcrData from "./OpenTcrData"
import { Dialog } from 'primereact/dialog';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faChartLine,
  faMoneyBillWave,
  faCreditCard,
  faRotateLeft,
  faTriangleExclamation,
  faArrowRightArrowLeft,
} from "@fortawesome/free-solid-svg-icons"
import jsPDF from "jspdf"
import autoTable from "jspdf-autotable"
import "./CashRegister.scss"

const CashRegisterNew = (props) => {
  const [expandedRows, setExpandedRows] = useState(null)
  const [expandedMobileBranches, setExpandedMobileBranches] = useState({})
  const { t, i18n } = useTranslation("translations")
  const [currentTcrStatPrint, setCurrentTcrStatPrint] = useState(null)
  const [stats, setStats] = useState(null)
  const [statsDate, setStatsDate] = useState(null)
  const [visible, setVisible] = useState(false)
  const {
    company: [fullCompany],
    user: [user],
    selectedCompany: [selectedCompany]
  } = useAppContext()

  const [data, setData] = useState([])
  const [pageLoading, setPageLoading] = useState(true)
  const branches = user?.companiesRights?.find(cr => selectedCompany == cr?.id)?.branches ?? []

  const defaultTotals = {
    cashTaxInclusiveAmount: 0, noncashTaxInclusiveAmount: 0,
    successInvoicesNo: 0, cashInvoicesNo: 0, noncashInvoicesNo: 0,
    cashCorrectiveTot: 0, nonashCorrectiveTot: 0,
    cashCorrectiveNo: 0, noncashCorrectiveNo: 0,
    errorInvoicesNo: 0, cashInit: 0, cashDeposit: 0, cashWithdraw: 0,
    cashEnd: 0, banknoteCashTot: 0,
    totalSales: 0, correctiveTotal: 0, cashBalance: 0,
  }

  const summaryTotals = useMemo(() => {
    if (!data || data.length === 0) return defaultTotals
    const totals = data.reduce((acc, row) => {
      acc.cashTaxInclusiveAmount += row.cashTaxInclusiveAmount ?? 0
      acc.noncashTaxInclusiveAmount += row.noncashTaxInclusiveAmount ?? 0
      acc.successInvoicesNo += row.successInvoicesNo ?? 0
      acc.cashInvoicesNo += row.cashInvoicesNo ?? 0
      acc.noncashInvoicesNo += row.noncashInvoicesNo ?? 0
      acc.cashCorrectiveTot += row.cashCorrectiveTot ?? 0
      acc.nonashCorrectiveTot += row.nonashCorrectiveTot ?? 0
      acc.cashCorrectiveNo += row.cashCorrectiveNo ?? 0
      acc.noncashCorrectiveNo += row.noncashCorrectiveNo ?? 0
      acc.errorInvoicesNo += row.errorInvoicesNo ?? 0
      acc.cashInit += row.cashInit ?? 0
      acc.cashDeposit += row.cashDeposit ?? 0
      acc.cashWithdraw += row.cashWithdraw ?? 0
      acc.cashEnd += row.cashEnd ?? 0
      acc.banknoteCashTot += row.banknoteCashTot ?? 0
      return acc
    }, {
      cashTaxInclusiveAmount: 0, noncashTaxInclusiveAmount: 0,
      successInvoicesNo: 0, cashInvoicesNo: 0, noncashInvoicesNo: 0,
      cashCorrectiveTot: 0, nonashCorrectiveTot: 0,
      cashCorrectiveNo: 0, noncashCorrectiveNo: 0,
      errorInvoicesNo: 0, cashInit: 0, cashDeposit: 0, cashWithdraw: 0,
      cashEnd: 0, banknoteCashTot: 0,
    })
    totals.totalSales = totals.cashTaxInclusiveAmount + totals.noncashTaxInclusiveAmount
    totals.correctiveTotal = totals.cashCorrectiveTot + totals.nonashCorrectiveTot
    totals.cashBalance = totals.cashEnd + totals.banknoteCashTot
    return totals
  }, [data])

  const businessUnitCodes = React.useMemo(() => {
    return [
      {
        label: t("invoice.businessUnitCode"),
        value: null,
      },
    ].concat(
      fullCompany?.branches?.map((branch) => {
        return {
          ...branch,
          label: branch.businUnitCode + " | " + branch.sellerName,
          value: branch.businUnitCode,
        }
      }) ?? []
    )
  }, [branches,fullCompany])



  const [persistedData, setPersistedData] = usePersistedState(
    null,
    "sessionData"
  )

  const businessUnitSelected = businessUnitCodes.some(
    (branch) => branch?.value === persistedData?.businessUnitCode
  )
    ? persistedData?.businessUnitCode
    : null

  // const [sessionData, setSessionData] = useState({
  //   fromDate:
  //     persistedData?.fromDate && persistedData?.toDate
  //       ? new Date(persistedData?.fromDate)
  //       : func.getDateFromToday(-3),
  //   toDate:
  //     persistedData?.fromDate && persistedData?.toDate
  //       ? new Date(persistedData?.toDate)
  //       : func.getDateFromToday(1),
  //   businessUnitCode: businessUnitSelected,
  // })

  const [sessionData, setSessionData] = useState({
    fromDate: new Date(),
    toDate: new Date(), 
    businessUnitCode: businessUnitSelected,
  });

  
  const groupedTotalsByBranch = (_allStats, selectedBusinessUnitCode) => {
    const filteredBranches = selectedBusinessUnitCode
      ? branches?.filter(b => b.businUnitCode === selectedBusinessUnitCode) ?? []
      : branches
    let allUserTcrs =
      filteredBranches?.reduce((acc, branch) => {
        return acc.concat(branch?.tcrTypes ?? [])
      }, []) ?? []

    let allStats=[]
    _allStats.forEach((stat) => {
      const foundUserTcr=allUserTcrs.find(user=> user.tcrCode===stat.tcrCode)
      if( foundUserTcr || stat?.tcrCode === "TS001NC001"){
        if(foundUserTcr?.status == -100){
          allStats.push({...stat,inactive:true})
        }else{
          allStats.push({...stat})
        }
      }
    })
    let zeroTcrs = allUserTcrs.flat()
    zeroTcrs =
      zeroTcrs?.filter(
        (tcr) =>
          allStats.every((stat) => stat.tcrCode !== tcr.tcrCode)
      ) ?? []
    let template = {
      buTcrStats: [],
    }

    Object.keys(allStats?.[0] ?? {}).forEach((key) => {
      if (typeof allStats?.[0]?.[key] === "number") {
        template[key] = 0
      } else {
        template[key] = ""
      }
    })
    const branchesOptions = filteredBranches.map((branch) => {
      return {
        ...branch,
        label: branch.businUnitCode + " - " + branch.sellerAddress,
        value: branch.businUnitCode + " - " + branch.sellerAddress,
      };
    });
  
    var result = []
    zeroTcrs = zeroTcrs.map((tcr) => {
      return {
        ...template,
        businessUnitCode: tcr?.businUnitCode,
        tcrCode: tcr.tcrCode,
        inactive: tcr?.status == -100
      }
    })

    allStats.push(...zeroTcrs)
    allStats.reduce((res, current) => {
      const curr = { ...current }
      const { id, tcrCode, actionFrom, company, recordDate, ...rest } = curr

      if (!res[curr.businessUnitCode]) {

        let sellerAddress =
          fullCompany?.branches?.find(
            (comp) => comp.businUnitCode === curr.businessUnitCode
          )?.sellerAddress 

        res[curr.businessUnitCode] = rest
        curr.cashEnd =   parseFloat(bigDecimal.add( (curr?.cashEnd ?? 0), (curr?.banknoteCashTot ?? 0)))

        result.push({
          ...rest,
          cashEnd: curr.cashEnd,
          sellerAddress,
          buTcrStats: curr.tcrCode !== "TS001NC001" ? [curr] : [],
        })
      } else {
        let index = result.findIndex(
          (st) => st.businessUnitCode === curr.businessUnitCode
        )
        curr.cashEnd = parseFloat(bigDecimal.add( (curr?.cashEnd ?? 0), (curr?.banknoteCashTot ?? 0)))

        if (curr.tcrCode !== "TS001NC001") result[index].buTcrStats.push(curr)
        Object.keys(rest).forEach((key) => {
          if (typeof curr[key] === "number") {
            const val = result?.[index]?.[key]
            if (val || val === 0) {
              result[index][key] += curr[key]
            }
            // if (key === "cashEnd") {
            //   result[index]["cashEnd"] += (curr?.banknoteCashTot ?? 0)
            // }
          }
        })
      }
      return res
    }, {})
    return result
  }

  const getCashDesposits=()=>{
    if (!(sessionData?.fromDate && sessionData?.toDate && fullCompany?.id)) {
      return
    }
    let endpoint = sessionData?.businessUnitCode
      ? "/endpoint/v2/reports/queue/branch/aggregate"
      : "/endpoint/v2/reports/queue/company/aggregate"
    mainAxios
      .post(endpoint, {
        object: "GetQueueCashDepositStatisticsAnalytics",
        fromDate: moment(sessionData?.fromDate).format("YYYY-MM-DD"),
        toDate: moment(sessionData?.toDate).format("YYYY-MM-DD"),
        ...(sessionData?.businessUnitCode
          ? { params: { businessUnitCode: sessionData?.businessUnitCode } }
          : {}),
      })
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.content)
          const results = groupedTotalsByBranch([...res.data.content], sessionData?.businessUnitCode)
          setStats(results)
          let date = moment().format("DD/MM/YYYY HH:mm")
          setStatsDate(date)
          setPageLoading(false)
        }
      })
      .catch((err) => {
        setPageLoading(false)
      })
  }
  useEffect(() => {
    getCashDesposits()
  }, [
    sessionData?.fromDate,
    sessionData?.toDate,
    sessionData?.businessUnitCode,
    fullCompany?.id,
  ])

  const printThermalInvoice = ({isSimple=false}={}) => {
    const content = document.getElementById("thermalPrinterInvoice")
    const originalTitle = document.title; 
    
    document.title = `Raporti i arkes ${isSimple?"i thjeshte":"standard"} ${ moment().format('DD MMM YYYY HH:mm')}`

    const pri = document.getElementById("ifmcontentstoprint").contentWindow
    pri.document.open()
    pri.document.write(
      `<html><style>@page{margin:5mm auto;margin-bottom:5mm;font-family: 'Trebuchet MS', Helvetica, sans-serif;}</style>${content.innerHTML}</html>`
    )
    pri.document.close()
    pri.focus()
    pri.print()
    setTimeout(() => {
      document.title = originalTitle;
    }, 1000);
  }
  const [tcrDataOnModal,setTcrDataOnModal]=useState()

  const openTcrData = (data, actionType, businUnitCode) => {
    const {
      cashDeposit: depositTotal,
      cashInit: initialTotal,
      tcrCode: tcr,
      cashWithdraw: withdrawTotal,
    } = data
    let tcrData = {
      depositTotal,
      initialTotal,
      tcr,
      withdrawTotal,
      cashEnd: (data?.cashEnd ?? 0)
    }
    setTcrDataOnModal({ ...tcrData, actionType, businUnitCode })

    // props.history.push({
    //   pathname: "/cashregister/tcr",
    //   state: { ...tcrData, actionType, businUnitCode },
    // })
  }

  const PrintActions = ({ row, type }) => {
    const menu = useRef()
    const pdfMenu = useRef()
    const items = [
      {
        label: t("stat.simpleReport"),
        command: () => {
          let simpleTcrStat = {}

          Object.keys(row).forEach((key) => {
            if (row[key] !== 0) {
              simpleTcrStat[key] = row[key]
            }
          })
          setCurrentTcrStatPrint({ tcrStat: simpleTcrStat, isSimple: true })
          setTimeout(() => {
            printThermalInvoice({isSimple:true})
          }, [150])
        },
      },
      {
        label: t("stat.standardReport"),
        command: () => {
          if ((type === "tcr" && row?.tcrCode) || type === "branch") {
            setCurrentTcrStatPrint({
              tcrStat: { ...row },
              isSimple: false,
            })
            setTimeout(() => {
              printThermalInvoice()
            }, [150])
          } else {
            setCurrentTcrStatPrint(null)
          }
        },
      },
    ]
    const pdfItems = [
      {
        label: t("stat.simpleReport"),
        icon: "pi pi-file-pdf",
        command: () => {
          let simpleTcrStat = {}
          Object.keys(row).forEach((key) => {
            if (row[key] !== 0) {
              simpleTcrStat[key] = row[key]
            }
          })
          generateTcrPdf(simpleTcrStat, true)
        },
      },
      {
        label: t("stat.standardReport"),
        icon: "pi pi-file-pdf",
        command: () => {
          if ((type === "tcr" && row?.tcrCode) || type === "branch") {
            generateTcrPdf({ ...row }, false)
          }
        },
      },
    ]
    return (
      <div className="d-flex align-items-center">
        <Button
          tooltip={type === "branch" ? t("stat.branchReport") : t("stat.tcrReport")}
          tooltipOptions={{
            position: "left",
            style: { padding: 0 },
          }}
          icon="pi pi-print"
          disabled={data?.length == 0}
          className="p-button-outlined p-button-success"
          style={{
            padding: "5px 8px",
            fontWeight: 600,
            fontSize: 12,
          }}
          onClick={(event) => menu.current.toggle(event)}
        />
        <Menu model={items} popup ref={menu} />
        <Button
          tooltip="PDF"
          tooltipOptions={{
            position: "left",
            style: { padding: 0 },
          }}
          icon="pi pi-file-pdf"
          disabled={data?.length == 0}
          className="p-button-outlined p-button-danger ml-2"
          style={{
            padding: "5px 8px",
            fontWeight: 600,
            fontSize: 12,
          }}
          onClick={(event) => pdfMenu.current.toggle(event)}
        />
        <Menu model={pdfItems} popup ref={pdfMenu} />
        {type == "tcr" && (
          <Button
            tooltip={t("navbar.cashRegister")}
            tooltipOptions={{
              position: "left",
              style: { padding: 0 },
            }}
            icon="pi pi-reply"
            className="p-button-outlined p-button-success ml-2"
            style={{
              padding: "5px 8px",
              fontWeight: 600,
              fontSize: 12,
            }}
            onClick={(e) =>{
              setVisible(true);
              openTcrData(
                {
                  ...row,
                  initialTotal:
                    row?.cashEnd ? row?.cashEnd : row?.initialTotal,
                },
                "INITIAL",
                row?.businessUnitCode
              )}
            }
          />
        )}
      </div>
    )
  }
  const allowExpansion = (rowData) => {
    return rowData?.buTcrStats?.length > 0
  }

  const branchColumns = [
    {
      expander: allowExpansion,
      style: { width: "0.5em" },
      field: "expansionCol",
      frozen: true,
    },
    {
      field: "sellerName",
      header: t("cashRegister.branchName"),
      body:(row)=>`${row.businessUnitCode} | ${row.sellerAddress}`,
      formatExportedValue:true,
      sortable: true,
      style:{ minWidth: '200px', maxWidth:"200px" },
    },
    {
      field: "banknoteCashTot",
      header: t("dashboard.salesCash"),
      body: (row) => func.getFormattedMoneyValue(row?.banknoteCashTot ?? 0),
    },
    {
      field: "cashDeposit",
      header: t("invoice.corrective"),
      body: (row) => func.getFormattedMoneyValue(row?.cashCorrectiveNo ?? 0),
      // style: { textAlign: "right" }
    },
    {
      field: "totals",
      header: t("dashboard.totals"),
      body: (row) =>
        func.getFormattedMoneyValue(
          (row?.cashEnd ?? 0)
        ),
    },
    {
      field: "actions",
      header: "Actions",
      body: (row) => PrintActions({ row, type: "branch" }),
    },
  ]

  const defaultCols = [
    "tcrCode",
    "cashInit",
    "cashInitNo",
    "cashWithdrawNo",
    "cashWithdraw",
    "cashDeposit",
    "cashDepositNo",
    "totals",
    "actions",
  ]
  const [selectedColumns, setSelectedColumns] = usePersistedState(
    defaultCols,
    "tcrColumns"
  )
  const onColumnToggle = (event) => {
    let selected = event?.value
    const cols = selected.filter(sel => !sel.persisted && !sel.frozen).map((sel) => sel.field)
    setSelectedColumns(cols)
  }

   // Function to determine cell style
 const getTcrCodeStyle = (row) => {
  return row.inactive ? { color: '#dc3545' } : {};
};


  // const {...defaultCols,...restColumns}=data?.[0] ?? {}

  const columns = useMemo(() => {
    const restCols =
      Object.keys(data?.[0] ?? {})?.filter(
        (key) => !defaultCols.includes(key) && key != "cashEnd"
      ) ?? []

    return [
      {
        field: "actions",
        header: t("cashRegister.actions"),
        style: { minWidth: "120px", maxWidth: "120px" },
        body: (row) => PrintActions({ row, type: "tcr" }),
        frozen: true,
        persisted: true
      },
      {
        field: "tcrCode",
        filter: true,
        showFilterMenu: false,
        showClearButton: false,
        header: t("cashRegister.tcrName"),
        style: { minWidth: "150px", maxWidth: "150px" },
        sortable: true,
        persisted: true,
        body: (row) => (
          <span style={getTcrCodeStyle(row)}>
            {row?.tcrCode}
          </span>
        ),
      },
      {
        field: "cashInit",
        header: t("cashRegister.initialTitle"),
        style: { minWidth: "150px", maxWidth: "150px" },
        body: (row) => func.getFormattedMoneyValue(row?.cashInit ?? 0),
        persisted: true
        // style: { textAlign: "right" }
      },
      {
        field: "cashInitNo",
        header: t("cashRegister.initialNo"),
        style: { minWidth: "150px", maxWidth: "150px" },
        persisted: true
      },
      {
        field: "cashWithdraw",
        header: t("cashRegister.withdrawTotal"),
        style: { minWidth: "150px", maxWidth: "150px" },
        body: (row) => func.getFormattedMoneyValue(row?.cashWithdraw ?? 0),
        persisted: true
        // style: { textAlign: "right" }

      },
      {
        field: "cashWithdrawNo",
        header: t("cashRegister.withdrawNo"),
        style: { minWidth: "150px", maxWidth: "150px" },
        persisted: true
      },
      {
        field: "cashDeposit",
        header: t("cashRegister.cashDepTot"),
        style: { minWidth: "150px", maxWidth: "150px" },
        // body: (row) => func.getFormattedMoneyValue(row?.cashDeposit ?? 0),
        persisted: true
      },
      {
        field: "cashDepositNo",
        style: { minWidth: "150px", maxWidth: "150px" },

        header: t("cashRegister.cashDepNo"),
        persisted: true
      },
      {
        field: "cashEnd",
        style: { minWidth: "150px", maxWidth: "150px" },

        header: t("dashboard.totals"),
        // body: (row) => {
        //   return func.getFormattedMoneyValue((row?.cashEnd ?? 0))
        // },
        persisted: true
      },


      ...restCols.map((key) => {
        let header = func.camelToFlat(key);
        let field = key;
        if (i18n.exists(`translations:stat.${key}`)) {
          header = t(`stat.${key}`);
        }
        return {
          header,
          field,
          style: { minWidth: "150px", maxWidth: "250px" },

        };
      }),
    ]
  }, [i18n.language, stats, data])

  const filteredColumns = useMemo(() => {
    let _filteredColumns = []
    selectedColumns.forEach((persistedCol) => {
      const column = columns.find((col) => col.field === persistedCol && !col?.frozen && !col?.persisted)
      if (column) _filteredColumns.push(column)
    })
    let persisted = columns?.filter((col) => col?.frozen || col?.persisted) ?? []

    return persisted.concat(_filteredColumns)
  }, [selectedColumns, data, i18n.language])

  const header = useMemo(() => {
    const filteredOptions = columns.filter(col => col.persisted || col.frozen)?.map(col => ({ field: col.field, persisted: true })) ?? []
    let value = columns.map(opt => opt.field) ?? []
    value = selectedColumns.filter(selectedField => value.includes(selectedField)).map(col => ({ field: col }))

    return (
      <div
        className="d-flex justify-content-end p-0"
        style={{ textAlign: "left" }}
      >
        <div className="mr-2">
          <ExportCsvMultiple
            data={data}
            selectedColumns={filteredColumns.map(col => ({ field: col.field, show: true }))}
            columns={columns}
            excludedColumns={["space", "actions", "expansionCol"]}
            asDropdown={true}
          />
        </div>
        <MultiSelect
          value={filteredOptions.concat(value)}
          scrollHeight="600px"
          dataKey="field"
          filter={true}
          options={columns}
          optionLabel="header"
          onChange={onColumnToggle}
          style={{ width: "14em" }}
          itemTemplate={(option) => {
            const disabled = option?.persisted;
            const style = { color: "#c1c1c1", fontweight: 500 }
            return <div style={disabled ? style : {}}>{option.header}</div>
          }}
        />
      </div>
    )
  }, [selectedColumns, data, filteredColumns])

  const rowExpansionTemplate = (data) => {
    return (
      <div className="prime-header-sticky">
        <DataTable
          reorderableColumns={true}
          filterDisplay="row"
          value={data.buTcrStats}
          responsiveLayout="scroll"
          className="white-header"
          dataKey="tcrCode"
          columnResizeMode="expand"
        >
          <Column key="space" frozen={true} field="space" style={{ minWidth: "100px",maxWidth:"100px" }} />
          {filteredColumns?.map((column) => {
            return <Column key={column?.field} {...column} />
          })}
          <Column key="spaceAfter" frozen={true} field="spaceAfter" style={{ width: "20px" }} />

        </DataTable>
      </div>
    )
  }

  const toggleMobileBranch = (buCode) => {
    setExpandedMobileBranches(prev => ({ ...prev, [buCode]: !prev[buCode] }))
  }

  const renderMobileCards = () => {
    if (!stats || stats.length === 0) {
      return <div className="cr-mobile-empty">{t("common.noData") || "No data"}</div>
    }
    return (
      <div className="cr-mobile-cards">
        {stats.map((branch) => {
          const isOpen = !!expandedMobileBranches[branch.businessUnitCode]
          const hasTcrs = branch.buTcrStats?.length > 0
          return (
            <div key={branch.businessUnitCode} className="cr-mobile-branch-card">
              {/* Branch header */}
              <div
                className={`cr-mobile-branch-card__header ${hasTcrs ? "clickable" : ""}`}
                onClick={() => hasTcrs && toggleMobileBranch(branch.businessUnitCode)}
              >
                <div className="cr-mobile-branch-card__name">
                  <span className="cr-mobile-branch-card__bu-code">{branch.businessUnitCode}</span>
                  <span className="cr-mobile-branch-card__address">{branch.sellerAddress}</span>
                </div>
                <div className="cr-mobile-branch-card__header-right">
                  <span className="cr-mobile-branch-card__total">
                    {func.getFormattedMoneyValue(branch.cashEnd ?? 0)} L
                  </span>
                  {hasTcrs && (
                    <i className={`pi ${isOpen ? "pi-chevron-up" : "pi-chevron-down"} cr-mobile-branch-card__chevron`} />
                  )}
                </div>
              </div>

              {/* Branch key stats */}
              <div className="cr-mobile-branch-card__stats">
                <div className="cr-mobile-branch-card__stat">
                  <span className="cr-mobile-branch-card__stat-label">{t("dashboard.salesCash")}</span>
                  <span className="cr-mobile-branch-card__stat-value">{func.getFormattedMoneyValue(branch.banknoteCashTot ?? 0)} L</span>
                </div>
                <div className="cr-mobile-branch-card__stat">
                  <span className="cr-mobile-branch-card__stat-label">{t("invoice.corrective")}</span>
                  <span className="cr-mobile-branch-card__stat-value">{func.getFormattedMoneyValue(branch.cashCorrectiveNo ?? 0)} L</span>
                </div>
                <div className="cr-mobile-branch-card__actions">
                  <PrintActions row={branch} type="branch" />
                </div>
              </div>

              {/* TCR sub-cards */}
              {isOpen && hasTcrs && (
                <div className="cr-mobile-branch-card__tcr-list">
                  <div className="cr-mobile-tcr-list-header">
                    <i className="pi pi-sitemap" />
                    <span>{t("cashRegister.tcrName")} ({branch.buTcrStats.length})</span>
                  </div>
                  {branch.buTcrStats.map((tcr, idx) => (
                    <div key={tcr.tcrCode} className={`cr-mobile-tcr-card ${tcr.inactive ? "inactive" : ""}`}>
                      <div className="cr-mobile-tcr-card__header">
                        <div className="cr-mobile-tcr-card__header-left">
                          <span className="cr-mobile-tcr-card__index">#{idx + 1}</span>
                          <span className="cr-mobile-tcr-card__code">{tcr.tcrCode}</span>
                          <span className={`cr-mobile-tcr-card__badge ${tcr.inactive ? "inactive" : "active"}`}>
                            {tcr.inactive ? t("common.inactive") : t("common.active")}
                          </span>
                        </div>
                        <PrintActions row={tcr} type="tcr" />
                      </div>
                      <div className="cr-mobile-tcr-card__flow">
                        <div className="cr-mobile-tcr-card__flow-row">
                          <span className="cr-mobile-tcr-card__flow-label">
                            <i className="pi pi-circle" /> {t("cashRegister.initialTitle")}
                          </span>
                          <span className="cr-mobile-tcr-card__flow-value">
                            {func.getFormattedMoneyValue(tcr.cashInit ?? 0)} L
                          </span>
                        </div>
                        <div className="cr-mobile-tcr-card__flow-row deposit">
                          <span className="cr-mobile-tcr-card__flow-label">
                            <i className="pi pi-plus-circle" /> {t("cashRegister.cashDepTot")}
                          </span>
                          <span className="cr-mobile-tcr-card__flow-value">
                            + {func.getFormattedMoneyValue(tcr.cashDeposit ?? 0)} L
                          </span>
                        </div>
                        <div className="cr-mobile-tcr-card__flow-row withdraw">
                          <span className="cr-mobile-tcr-card__flow-label">
                            <i className="pi pi-minus-circle" /> {t("cashRegister.withdrawTotal")}
                          </span>
                          <span className="cr-mobile-tcr-card__flow-value">
                            - {func.getFormattedMoneyValue(tcr.cashWithdraw ?? 0)} L
                          </span>
                        </div>
                        <div className="cr-mobile-tcr-card__flow-row total">
                          <span className="cr-mobile-tcr-card__flow-label">
                            <i className="pi pi-wallet" /> {t("dashboard.totals")}
                          </span>
                          <span className="cr-mobile-tcr-card__flow-value">
                            {func.getFormattedMoneyValue(tcr.cashEnd ?? 0)} L
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )
        })}
      </div>
    )
  }

  const generateTcrPdf = (tcrStat, isSimple = false) => {
    if (!tcrStat) return

    const userCompany = user.companiesRights.find(company => company.id === tcrStat["company"])
    const doc = new jsPDF({ orientation: "portrait" })

    const primaryColor = [0, 117, 103]
    const darkGray = [51, 51, 51]
    const mediumGray = [102, 102, 102]
    let y = 15

    // Header
    doc.setFontSize(14)
    doc.setTextColor(...primaryColor)
    doc.text(`${t("stat.cashRegisterReporting")} ${isSimple ? t("stat.simple") : t("stat.standart")}`, 14, y)
    y += 8

    doc.setFontSize(12)
    doc.setTextColor(...darkGray)
    doc.text(userCompany?.name || fullCompany?.name || "", 14, y)
    y += 10

    // Meta info
    doc.setFontSize(9)
    doc.setTextColor(...mediumGray)
    doc.text(`${t("stat.generatedFrom")}: ${(user?.firstName ?? "") + (user.lastName ? " " + (user?.lastName ?? "") : "")}`, 14, y)
    y += 5
    doc.text(`${t("stat.generatedDate")}: ${moment().format("DD/MM/YYYY HH:mm")}`, 14, y)
    y += 5
    doc.text(`${t("stat.toDate")}: ${moment(sessionData.toDate).format("DD/MM/YYYY")}`, 14, y)
    y += 5
    if (tcrStat.tcrCode) {
      doc.text(`${t("stat.tcrCode")}: ${tcrStat.tcrCode}`, 14, y)
      y += 5
    }
    if (tcrStat.businessUnitCode) {
      doc.text(`${t("nslf.businessUnitCode")}: ${tcrStat.businessUnitCode}`, 14, y)
      y += 5
    }
    y += 5

    // Sections (same as CashRegisterThermal)
    const sections = [
      {
        header: t("stat.totalNoAndValue"),
        rows: [
          [t("stat.totInvoicesNo"), tcrStat["totInvoicesNo"]],
          [t("stat.successInvoicesNo"), tcrStat["successInvoicesNo"]],
          [t("stat.errorInvoicesNo"), tcrStat["errorInvoicesNo"]],
          [t("stat.nonCashInvoicesNo"), tcrStat["noncashInvoicesNo"]],
          [t("stat.eInvoicesNo"), tcrStat["einvoicesNo"]],
          [t("stat.fiscalizedInvoicesNo"), tcrStat["fiscalizatedInvoicesNo"]],
          [t("stat.cashCorrectiveNo"), tcrStat["cashCorrectiveNo"]],
          [t("stat.nonCashCorrectiveNo"), tcrStat["noncashCorrectiveNo"]],
          [t("stat.totalWithoutVat"), func.getFormattedMoneyValue(tcrStat["totalWithoutVat"] ?? 0)],
          [t("stat.totalVat"), func.getFormattedMoneyValue(tcrStat["totalVat"] ?? 0)],
          [t("stat.totalWithVat"), func.getFormattedMoneyValue(tcrStat["totalWithVat"] ?? 0)],
        ]
      },
      {
        header: t("stat.cashTransactions"),
        rows: [
          [t("stat.cashInit"), func.getFormattedMoneyValue(tcrStat["cashInit"] ?? 0)],
          [t("stat.cashDeposit"), func.getFormattedMoneyValue(tcrStat["cashDeposit"] ?? 0)],
          [t("stat.cashWithdraw"), func.getFormattedMoneyValue(tcrStat["cashWithdraw"] ?? 0)],
        ]
      },
      {
        header: t("stat.cashAndNonCash"),
        rows: [
          [t("stat.nonCashTaxExclusiveAmount"), func.getFormattedMoneyValue(tcrStat["noncashTaxExclusiveAmount"] ?? 0)],
          [t("stat.nonCashTaxAmount"), func.getFormattedMoneyValue(tcrStat["noncashTaxAmount"] ?? 0)],
          [t("stat.nonCashTaxInclusiveAmount"), func.getFormattedMoneyValue(tcrStat["noncashTaxInclusiveAmount"] ?? 0)],
          [t("stat.cashTaxExclusiveAmount"), func.getFormattedMoneyValue(tcrStat["cashTaxExclusiveAmount"] ?? 0)],
          [t("stat.cashTaxAmount"), func.getFormattedMoneyValue(tcrStat["cashTaxAmount"] ?? 0)],
          [t("stat.cashTaxInclusiveAmount"), func.getFormattedMoneyValue(tcrStat["cashTaxInclusiveAmount"] ?? 0)],
          [t("stat.cashCorrectiveTot"), func.getFormattedMoneyValue(tcrStat["cashCorrectiveTot"] ?? 0)],
          [t("stat.einvoiceTaxExclusiveAmount"), func.getFormattedMoneyValue(tcrStat["einvoiceTaxExclusiveAmount"] ?? 0)],
          [t("stat.einvoiceTaxAmount"), func.getFormattedMoneyValue(tcrStat["einvoiceTaxAmount"] ?? 0)],
          [t("stat.einvoiceTaxInclusiveAmount"), func.getFormattedMoneyValue(tcrStat["einvoiceTaxInclusiveAmount"] ?? 0)],
          [t("stat.nonCashCorrectiveTot"), func.getFormattedMoneyValue(tcrStat["nonashCorrectiveTot"] ?? 0)],
        ]
      },
      {
        header: t("stat.paymentsValue"),
        rows: [
          [t("stat.banknoteTot"), func.getFormattedMoneyValue(tcrStat["banknoteTot"] ?? 0)],
          [t("stat.cardTot"), func.getFormattedMoneyValue(tcrStat["cardTot"] ?? 0)],
          [t("stat.svoucherTot"), func.getFormattedMoneyValue(tcrStat["svoucherTot"] ?? 0)],
          [t("stat.companyTot"), func.getFormattedMoneyValue(tcrStat["companyTot"] ?? 0)],
          [t("stat.orderTot"), func.getFormattedMoneyValue(tcrStat["orderTot"] ?? 0)],
          [t("stat.cashInvoicesNo"), tcrStat["cashInvoicesNo"]],
        ]
      },
      {
        header: t("stat.globalStatistics"),
        rows: [
          [t("stat.foreignInvoicesNo"), tcrStat["foreignInvoicesNo"]],
          [t("stat.allCurrencyInvoicesNo"), tcrStat["allCurrencyInvoicesNo"]],
          [t("stat.usdCurrencyInvoicesNo"), tcrStat["usdCurrencyInvoicesNo"]],
          [t("stat.eurCurrencyInvoicesNo"), tcrStat["eurCurrencyInvoicesNo"]],
          [t("stat.selfInvoicesNo"), tcrStat["selfInvoicesNo"]],
          [t("stat.subseqInvoicesNo"), tcrStat["subseqInvoicesNo"]],
          [t("stat.correctedInvoicesNo"), tcrStat["correctedInvoicesNo"]],
          [t("stat.cashSubseqActionNo"), tcrStat["cashSubseqActionNo"]],
          [t("stat.cashInit"), tcrStat["cashInit"]],
          [t("stat.cashDeposit"), tcrStat["cashDeposit"]],
          [t("stat.cashWithdraw"), tcrStat["cashWithdraw"]],
        ]
      },
      {
        header: t("stat.cashEnd"),
        rows: [
          [t("stat.subseqInvoicesTotal"), tcrStat["subseqInvoicesTotal"]],
          [t("stat.total"), func.getFormattedMoneyValue(tcrStat["cashEnd"] ?? 0)],
        ]
      }
    ]

    sections.forEach((section) => {
      const filteredRows = isSimple
        ? section.rows.filter(([label, value]) => value !== undefined && value !== 0 && parseInt(value) !== 0 && label !== t("stat.total"))
        : section.rows.filter(([, value]) => value !== undefined)

      if (isSimple && filteredRows.length === 0) return

      // Check page space
      if (y > 260) {
        doc.addPage()
        y = 15
      }

      doc.setFontSize(10)
      doc.setTextColor(...primaryColor)
      doc.setFont(undefined, "bold")
      doc.text(section.header, 14, y)
      y += 2
      doc.setDrawColor(200, 200, 200)
      doc.line(14, y, 196, y)
      y += 5

      doc.setFontSize(9)
      doc.setFont(undefined, "normal")
      const rowsToDraw = isSimple ? filteredRows : section.rows.filter(([, value]) => value !== undefined)
      rowsToDraw.forEach(([label, value]) => {
        if (y > 280) {
          doc.addPage()
          y = 15
        }
        doc.setTextColor(...darkGray)
        doc.text(label, 16, y)
        doc.text(String(value ?? ""), 196, y, { align: "right" })
        y += 5
      })
      y += 5
    })

    const reportType = isSimple ? t("stat.simple") : t("stat.standart")
    const fileName = `Raporti_arkes_${reportType}_${moment().format("YYYY-MM-DD")}.pdf`
    doc.save(fileName)
  }

  if (pageLoading) return <Loader />

  return (
    <div className="cash-register-page">
      <Dialog header={t("cashRegister.action")} visible={visible} style={{ width: '45vw', zIndex: -100 }} onHide={() => setVisible(false)}>
        {visible && <OpenTcrData data={tcrDataOnModal} onChange={() => { getCashDesposits() }} onClose={() => { setVisible(false) }} />}
      </Dialog>

      <div className="d-none">
        {currentTcrStatPrint?.tcrStat && (
          <CashRegisterThermal
            tcrStat={{
              fromDate: sessionData.fromDate,
              toDate: sessionData.toDate,
              statsDate: statsDate,
              ...currentTcrStatPrint?.tcrStat,
            }}
            isSimple={currentTcrStatPrint.isSimple}
          />
        )}
        <iframe id="ifmcontentstoprint"></iframe>
      </div>

      <div className="cash-register-page__header">
        <h1 className="cash-register-page__title">{t("navbar.cashRegister")}</h1>
        <div className="d-flex align-items-center" style={{ gap: "0.75rem" }}>
          <DateRange
            fromDate={sessionData.fromDate}
            toDate={sessionData.toDate}
            onChange={(dates) => {
              let fromDate = dates[0]
              let toDate = dates[1]
              setPersistedData({ ...persistedData, fromDate, toDate })
              setSessionData({ ...sessionData, fromDate, toDate })
            }}
          />
          <div className="d-flex align-items-center" style={{ minWidth: "220px" }}>
            <span className="cash-register-page__filters-field--bu-label">BU</span>
            <Select
              styles={selectStyle}
              className="w-100"
              options={businessUnitCodes}
              value={
                businessUnitCodes.find(
                  (businessUnitCode) =>
                    businessUnitCode.value === sessionData.businessUnitCode
                ) || {
                  label: t("invoice.businessUnitCode"),
                  value: "",
                }
              }
              isSearchable={true}
              onChange={(businessUnitCode) => {
                setPersistedData({
                  ...persistedData,
                  businessUnitCode: businessUnitCode.value,
                })
                setSessionData({
                  ...sessionData,
                  businessUnitCode: businessUnitCode.value,
                })
              }}
              name="businessUnitCode"
            />
          </div>
        </div>
      </div>

      <div className="cash-register-page__stats-row">
          <div className="cash-register-page__stat-card cash-register-page__stat-card--primary">
            <div className="cash-register-page__stat-icon">
              <FontAwesomeIcon icon={faChartLine} />
            </div>
            <div className="cash-register-page__stat-content">
              <span className="cash-register-page__stat-label">{t("dashboard.totalSales")}</span>
              <span className="cash-register-page__stat-value">{func.getFormattedMoneyValue(summaryTotals.totalSales)} L</span>
              <span className="cash-register-page__stat-count">#{summaryTotals.successInvoicesNo}</span>
            </div>
          </div>
          <div className="cash-register-page__stat-card cash-register-page__stat-card--teal">
            <div className="cash-register-page__stat-icon">
              <FontAwesomeIcon icon={faMoneyBillWave} />
            </div>
            <div className="cash-register-page__stat-content">
              <span className="cash-register-page__stat-label">{t("dashboard.cash")}</span>
              <span className="cash-register-page__stat-value">{func.getFormattedMoneyValue(summaryTotals.cashTaxInclusiveAmount)} L</span>
              <span className="cash-register-page__stat-count">#{summaryTotals.cashInvoicesNo}</span>
            </div>
          </div>
          <div className="cash-register-page__stat-card cash-register-page__stat-card--purple">
            <div className="cash-register-page__stat-icon">
              <FontAwesomeIcon icon={faCreditCard} />
            </div>
            <div className="cash-register-page__stat-content">
              <span className="cash-register-page__stat-label">{t("dashboard.nonCash")}</span>
              <span className="cash-register-page__stat-value">{func.getFormattedMoneyValue(summaryTotals.noncashTaxInclusiveAmount)} L</span>
              <span className="cash-register-page__stat-count">#{summaryTotals.noncashInvoicesNo}</span>
            </div>
          </div>
          <div className="cash-register-page__stat-card cash-register-page__stat-card--warning">
            <div className="cash-register-page__stat-icon">
              <FontAwesomeIcon icon={faRotateLeft} />
            </div>
            <div className="cash-register-page__stat-content">
              <span className="cash-register-page__stat-label">{t("invoice.corrective")}</span>
              <span className="cash-register-page__stat-value">{func.getFormattedMoneyValue(summaryTotals.correctiveTotal)} L</span>
              <span className="cash-register-page__stat-count">#{summaryTotals.cashCorrectiveNo + summaryTotals.noncashCorrectiveNo}</span>
            </div>
          </div>
          <div className="cash-register-page__stat-card cash-register-page__stat-card--danger">
            <div className="cash-register-page__stat-icon">
              <FontAwesomeIcon icon={faTriangleExclamation} />
            </div>
            <div className="cash-register-page__stat-content">
              <span className="cash-register-page__stat-label">{t("dashboard.errors")}</span>
              <span className="cash-register-page__stat-value">{summaryTotals.errorInvoicesNo}</span>
            </div>
          </div>
          <div className="cash-register-page__stat-card cash-register-page__stat-card--blue">
            <div className="cash-register-page__stat-icon">
              <FontAwesomeIcon icon={faArrowRightArrowLeft} />
            </div>
            <div className="cash-register-page__stat-content">
              <span className="cash-register-page__stat-label">{t("dashboard.cashBalance")}</span>
              <span className="cash-register-page__stat-value">{func.getFormattedMoneyValue(summaryTotals.cashBalance)} L</span>
            </div>
          </div>
      </div>

      {/* Desktop table */}
      <div className="cash-register-page__table-card cash-register-page__desktop-only">
        <div className="datatable-rowgroup-demo cash-register">
          <DataTable
            rowClassName="datadatble-row-style"
            value={stats}
            expandedRows={expandedRows}
            stripedRows
            header={header}
            onRowToggle={(e) => setExpandedRows(e.data)}
            responsiveLayout="scroll"
            rowExpansionTemplate={rowExpansionTemplate}
            dataKey="businessUnitCode"
            filterDisplay="menu"
          >
            {branchColumns.map((column) => {
              return <Column {...column} />
            })}
          </DataTable>
        </div>
      </div>

      {/* Mobile card view */}
      <div className="cash-register-page__mobile-only">
        {renderMobileCards()}
      </div>
    </div>
  )
}

export default CashRegisterNew
